import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { LogIn, Mic2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (user) return <Navigate to={location.state?.from?.pathname || "/"} replace />;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError("");
    const result = await login({ email, password });
    setIsSubmitting(false);
    if (!result.ok) {
      setError(result.error);
      return;
    }
    navigate(location.state?.from?.pathname || "/", { replace: true });
  };

  return (
    <main className="auth-page" data-testid="login-page">
      <section className="auth-panel" data-testid="login-panel">
        <div className="auth-brand" data-testid="login-brand-block">
          <span className="auth-logo" data-testid="login-logo-mark"><Mic2 size={24} /></span>
          <div>
            <p className="section-kicker" data-testid="login-page-kicker">acesso do aluno</p>
            <h1 className="font-display text-4xl font-black sm:text-5xl" data-testid="login-page-heading">Entre para continuar sua prática.</h1>
          </div>
        </div>
        <form className="auth-form" onSubmit={handleSubmit} data-testid="login-form">
          <label className="auth-label" htmlFor="login-email-input" data-testid="login-email-label">Email</label>
          <input id="login-email-input" className="auth-input" type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" required data-testid="login-email-input" />
          <label className="auth-label" htmlFor="login-password-input" data-testid="login-password-label">Senha</label>
          <input id="login-password-input" className="auth-input" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required data-testid="login-password-input" />
          {error && <div className="auth-error" role="alert" data-testid="login-error-alert">{error}</div>}
          <button className="primary-action" type="submit" disabled={isSubmitting} data-testid="login-submit-button">
            {isSubmitting ? "Entrando..." : "Entrar"} <LogIn size={18} />
          </button>
        </form>
        <p className="auth-switch" data-testid="login-register-prompt">
          Novo aluno? <Link to="/register" data-testid="login-register-link">Criar conta</Link>
        </p>
      </section>
    </main>
  );
}